import React from 'react'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'
import { WrappedStoryStateProvider } from 'contexts/Wrapped'
import WrappedLoadingState from './WrappedLoadingState'
import WrappedErrorState from './WrappedErrorState'
import WrappedStoryContent from './WrappedStoryContent'
import useWrappedData from '../hooks/useWrappedData'

const FullPageContainer = styled.div`
  position: fixed;
  inset: 0;
  height: 100vh;
  height: 100dvh;
  z-index: ${zIndex.menuInModal};
  background-color: ${props => props.theme.palette.neutral.default.one};
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
`

interface Props {
  uuid?: string
  onClose?: () => void
}

function WrappedStoryMobile({ uuid, onClose }: Props) {
  const { isLoading, hasError, error, data, state, dispatch, handleRetry } = useWrappedData({ uuid })

  return (
    <FullPageContainer className="is-full-page">
      {isLoading && <WrappedLoadingState />}
      {hasError && <WrappedErrorState error={error ?? undefined} onRetry={handleRetry} onClose={onClose} />}
      {!isLoading && !hasError && data && (
        <WrappedStoryStateProvider state={state} dispatch={dispatch}>
          <WrappedStoryContent mode="fullPage" onClose={onClose} />
        </WrappedStoryStateProvider>
      )}
    </FullPageContainer>
  )
}

export default WrappedStoryMobile
